import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProjectStatusCountArrayModel, ProjectStatusCountModel } from "../../models/ProjectStatusCountModel";

const initialProjectStatusCountState: ProjectStatusCountArrayModel = {
    projectStatusCounts: {
        "SavedAsDraft": 0,
        "Drafted": 0,
        "Submitted": 0,
        "Approved": 0,
        "Rejected": 0,
        "Total": 0
    }
}
const ProjectStatusCountSlice = createSlice({
    name: 'ProjectStatusCount',
    initialState: initialProjectStatusCountState,
    reducers: {
        setProjectStatusCount(state, action: PayloadAction<ProjectStatusCountModel>) {
            state.projectStatusCounts = action.payload;
        }
    }
})
export default ProjectStatusCountSlice;